document.addEventListener('DOMContentLoaded', function(event) {
  var allConnectivityCards = document.querySelectorAll('.connectivity-card');
  allConnectivityCards.forEach((el, index) => {
    var video = el.querySelector('video');
    if (video) {
      el.addEventListener("mouseover", (event) => {
        if (el.classList.contains('active')) return;
        el.classList.add('active');
        video.currentTime = 0.01;
        video.play();
      });
      el.addEventListener("mouseleave", (event) => {
          el.classList.remove('active');
      });  
    }
  });
});